import { createSelector } from "@reduxjs/toolkit"

// export const selectedDetailingSelector = createSelector<
//   RootState,
//   DetailingState["detailings"],
//   DetailingState["selectedDetailingCode"],
//   DetailingState["detailings"][number] | undefined
// >(
//   (state) => state.detailing.detailings,
//   (state) => state.detailing.selectedDetailingCode,
//   (detailings, selectedDetailingCode) =>
//     detailings.find(
//       (detailing) => detailing.details.code === selectedDetailingCode
//     )
// )

// export const previousDetailingNameSelector = createSelector<
//   RootState,
//   DetailingState["detailings"],
//   DetailingState["selectedDetailingCode"],
//   DetailingState["detailings"][number]["details"]["name"] | null
// >(
//   (state) => state.detailing.detailings,
//   (state) => state.detailing.selectedDetailingCode,
//   (detailings, selectedDetailingCode) => {
//     const selectedDetailingIndex = detailings.findIndex(
//       (detailing) => detailing.details.code === selectedDetailingCode
//     )
//     if (selectedDetailingIndex <= 0) return null

//     return detailings[selectedDetailingIndex - 1].details.name
//   }
// )
export const selectedDetailingSelector = createSelector(
  (state) => state.detailing.detailings,
  (state) => state.detailing.selectedDetailingCode,
  (detailings, selectedDetailingCode) =>
    detailings.find(
      (detailing) => detailing.details.code === selectedDetailingCode
    )
)

export const selectedEngineSelector = createSelector(
  (state) => state.detailing.engines,
  (state) => state.detailing.selectedDetailingCode,
  (engines, selectedDetailingCode) =>
    engines.find((engine) =>
      engine.finishingLevels.some(
        (detailing) => detailing.details.code === selectedDetailingCode
      )
    )
)

export const previousDetailingNameSelector = createSelector(
  (state) => state.detailing.detailings,
  (state) => state.detailing.selectedDetailingCode,
  (detailings, selectedDetailingCode) => {
    const selectedDetailingIndex = detailings.findIndex(
      (detailing) => detailing.details.code === selectedDetailingCode
    )
    if (selectedDetailingIndex <= 0) return null

    return detailings[selectedDetailingIndex - 1].details.name
  }
)
